import axios from 'axios';

export const state = () => ({
    assignedToMeCount: 0
});

export const getters = {
    assignedToMeCount: state => state.assignedToMeCount
};

export const mutations = {
    SET_ASSIGNED_TO_ME_COUNT(state, val) {
        state.assignedToMeCount = val;
    }
};

export const actions = {
    index(vuexContext, { userId, socialType, sortBy, order }) {
        const params = {
            userId
        };

        if (socialType) {
            params.socialType = socialType;
        }

        params.sortBy = sortBy;
        params.order = order;

        return axios.$get('/v1/feed-items', {
            params
        });
    },

    updateState(vuexContext, data) {
        return axios.$post('/v1/feed-items/status/properties/state', data);
    },

    translate(vuexContext, data) {
        return axios.$post('/v1/feed-items/status/properties/translate', data);
    },

    assign(vuexContext, data) {
        return axios.$post(`/v1/feed-items/${data.id}/assign`, data);
    },

    unassign(vuexContext, id) {
        return axios.$post(`/v1/feed-items/${id}/unassign`);
    },

    setLabels(vuexContext, data) {
        return axios.$post(`/v1/feed-items/${data.id}/set-labels`, data);
    },

    async getAssignedToMeCount({ commit }) {
        const assignedToMeCount = await axios.$get('/v1/feed-items/assigned-to-me-count');

        commit('SET_ASSIGNED_TO_ME_COUNT', assignedToMeCount);
    },

    getAssignedToMe(vuexContext, { sortBy, order }) {
        const params = {};

        params.sortBy = sortBy;
        params.order = order;

        return axios.$get('/v1/feed-items/assigned-to-me', { params });
    },

    searchResults(vuexContext, { userId, sentiment = null, socialTypes }) {
        const params = {
            userId,
            sentiment,
            socialTypes
        };

        return axios.$get('/v1/feed-items/search-results', { params });
    },

    count(vuexContext, userId) {
        const params = {
            user_id: userId
        };

        return axios.$get('/v1/feed-items/count', { params });
    },

    sentiments(vuexContext, userId) {
        const params = {
            user_id: userId
        };

        return axios.$get('/v1/feed-items/sentiments', { params });
    },

    drafts(vuexContext, userId) {
        const params = {
            user_id: userId
        };

        return axios.$get('/v1/feed-items/drafts', { params });
    }
};
